const bpak = {
  hero: {
    title: 'UAS PEGASUS ARMS 25 — a reliable solution for combat missions',
    paragraphs: [
      'The Pegasus Arms 25 UAS is an unmanned aviation system engineered by Ukrainian specialists to meet the modern challenges of the battlefield. The system combines high strike effectiveness, strong EW resistance, and adaptability to tasks of varying complexity.',
      'With the Pegasus Arms 25 UAS, units gain an autonomous tool for striking enemy equipment, manpower, and engineering structures without exposing personnel to direct danger. It is a solution that saves lives, shortens mission execution time, and enables independent operation — day or night, in simple or complex weather conditions, with autonomous return-to-base and EW resilience.',
    ],
  },

  advantages: {
    title: 'TECHNICAL ADVANTAGES OF THE UAS',
    timeLine: [
      {
        title: 'PAYLOAD CAPACITY',
        description:
          '14 kg: compatible with PG-7, TM, SVP and other munitions for a wide range of missions — from striking armored targets to remote mining.',
      },
      {
        title: 'COMBAT RANGE',
        description:
          'up to 20 km. Allows engaging the enemy without risking the UAS crew.',
      },
      {
        title: 'GNSS ANTENNA',
        description:
          'A proprietary GNSS antenna improves navigation accuracy and reliability under spoofing and jamming conditions.',
      },
      {
        title: 'EW RESISTANCE',
        description:
          'stable control and mission execution even in areas with active electronic warfare.',
      },
      {
        title: 'DUAL-SPECTRUM CAMERA',
        description:
          '(optical + thermal) enables round-the-clock target acquisition.',
      },
      {
        title: 'AUTONOMOUS RETURN',
        description:
          'AUTONOMOUS RETURN-TO-BASE function in case of signal loss. Minimizes the risk of losing the UAV even in difficult combat environments.',
      },
    ],
  },

  composition: {
    title: 'COMPOSITION OF THE PEGASUS ARMS 25 UAS',
    paragraphs: [
      'The system has several configuration options depending on mission type: strike tasks, logistics, or remote mining.',
      'Any number of Pegasus Arms 25 UAVs can be connected to a single system.',
    ],
    items: [
      'Unmanned aerial vehicle',
      'Ground control station with remote controller',
      'Laptop for UAV management and portable monitor',
      'Communication module',
      'Battery packs',
      'Software package',
      'Transport/storage case and auxiliary equipment kit',
      'Operational documentation',
    ],
  },
}

export default bpak
